import { render, staticRenderFns } from "./PlanoForm.vue?vue&type=template&id=745c0b88&scoped=true&"
import script from "./PlanoForm.vue?vue&type=script&lang=js&"
export * from "./PlanoForm.vue?vue&type=script&lang=js&"
import style0 from "./PlanoForm.vue?vue&type=style&index=0&id=745c0b88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745c0b88",
  null
  
)

export default component.exports